import React, { FC, useMemo } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PartsEquipmentWorkOrdersList from '../parts_equipment_work_orders_list/PartsEquipmentWorkOrdersList';

const PartsPerStockLocationWorkOrdersPage: FC<any> = ({ match }): React.ReactElement => {
	const partsPerStockLocationId = useMemo(() => match.params.id, [match.params.id]);

	return (
		<PartsEquipmentWorkOrdersList
			preAppliedFilters={{ partsPerStockLocationId }}
			backText="Back to Part"
			showQuantity
		/>
	);
};

export default withRouter<any, any>(connect()(PartsPerStockLocationWorkOrdersPage));
